import './Inicio.css';
import logo from '../assets/stem.png'; 
import cursoImg from '../assets/ruta-del-curso.png';

const Inicio = () => {
  return (
    <section id="inicio" className="inicio-container">
      <div className="contenido">
        <div className="lado">
          <img src={logo} alt="Logo STEM" className="imagen" />
        </div>
        <div className="lado">
          <img src={cursoImg} alt="Cursos" className="imagen" />
        </div>
      </div>

      <div className="bloque-texto">
        <h4 className="subtitulo">SOLUCIONES TÉCNICAS A TU ALCANCE</h4>

        <p className="intro-inicio">
          En STEM Instituto México ofrecemos cursos y programas de capacitación
          técnica, desarrollo de materiales profesionales y consultorías
          especializadas en ingeniería, energía e innovación tecnológica.
        </p>

        <p className="intro-inicio">
          Nuestros servicios están diseñados para apoyar a empresas,
          instituciones y gobiernos en México y Latinoamérica, traduciendo el
          conocimiento técnico en resultados reales.
        </p>
      </div>
    </section>
  );
};

export default Inicio;
